import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import DashboardService from "../../services/Dashboard";

const initialState = {
    dashboardCardOrder:{},
    hiddenColumns: {}
  };
  export const getDashboardOrder = createAsyncThunk(
    "userPref/getDashboardOrder",
    async (data, thunkAPI) => {
      const response = await DashboardService.getPreference();
      return response;
    }
  );
  export const setDashboardOrder = createAsyncThunk(
    "userPref/setDashboardOrder",
    async (data: any, thunkAPI) => {
      const response = await DashboardService.setPreference(data);
      thunkAPI.dispatch(getDashboardOrder());
      return response;
    }
  );
export const userPrefSlice = createSlice({
    name: "userPref",
    initialState,
    reducers: {
        updateDashboardOrder: (
            state,
            action
          ) => {
            state.dashboardCardOrder = action.payload?.filter(
              (card) => card.name !== "FUNNEL"
            );
          },
      updateHiddenColumns: (state, action) => {
        state.hiddenColumns = action.payload;
      },
      
    },
    extraReducers: (builder) => {
      
      builder.addCase(getDashboardOrder.fulfilled, (state, action: any) => {
        state.hiddenColumns = action.payload?.hiddenColumns || {};
      });
      
      
    }
  });
export const {
  updateDashboardOrder,
    updateHiddenColumns
  } = userPrefSlice.actions;
  
  export default userPrefSlice.reducer;